export type VehicleType = 'suv' | 'van'

export const VEHICLE_TYPES: VehicleType[] = ['suv', 'van']

export function getVehicleType<T>(obj: Record<VehicleType, T>, vehicleType: VehicleType): T {
  return obj[vehicleType]
}

export function getAllVehicleTypes(): VehicleType[] {
  return VEHICLE_TYPES
}
